<template>
    <div >
        <div class="page">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div v-for="(item,index) in orderList" :key="item"  class="notice-item">
                    <van-row  type="flex" justify="space-between" align="center" class="info-top">
                        <van-col class="gem-name">
                            {{item.venueName}}
                        </van-col>
                        <van-col class="order-status">
                            {{item.state==0?'待支付':item.state==1?'已支付':item.state==2?'已使用':item.state==3?'已取消':item.state==4?'退款中':item.state==5?'已退款':''}}
                        </van-col>
                    </van-row>
                    <van-row class="info-msg">
                        价格：¥{{item.totalPrice}}
                    </van-row>
                    <van-row class="info-msg">
                        预约时间：{{item.appointTime}}
                    </van-row>
                    <van-row class="info-msg">
                        预约场地：{{item.venueSubName}}
                    </van-row>
                    <van-row class="info-msg">
                        下单时间：{{item.createDate}}
                    </van-row>
                    <van-row type="flex" justify="end" class="action-area">
                        <van-col class="action" @click="payOrder(item.orderNum,item.totalPrice)" v-if="item.state==0">支付</van-col>
                        <van-col class="action" @click="orderAction(item.orderNum)" v-if="(item.state==0 || item.state==1)&&item.canCancel==1">取消订单</van-col>
                        <van-col class="action" v-if="item.state>2&&item.applyState==1">已退款</van-col>
                        <van-col class="action" v-if="item.state>2&&item.applyState==2">已拒绝</van-col>
                        <van-col class="action" v-if="item.state>2&&item.applyState==3">退款中</van-col>
                        <van-col class="action" v-if="item.state>2&&item.applyState==0">待处理</van-col>
                    </van-row>

                </div>
            </van-list>
        </div>
    </div>

</template>

<script>
    import { Toast } from 'vant';
    import {getOrder} from '@/api/api'
    import {cancelOrder} from '@/api/api'
    export default {
        name: "my-order",
        data(){
            return{
                loading:false,
                finished:true,
                orderList:[]
            }
        },
        created(){
            this.getList()
        },
        methods:{
            getList(){
                let params = {
                    pageNo:1,
                    pageSize:50
                }
                getOrder(params).then(res=>{
                    if (res.code==0){
                        this.orderList = res.data.list
                    }else{
                        Toast(res.msg)
                    }
                })
            },
            onLoad(){

            },
            payOrder(ordernum,price){
                this.$router.push({path: '/payinfo', query: {ordernum, price}})
            },
            orderAction(ordernum){
                let params = {
                    orderNum:ordernum
                }
                cancelOrder(params).then(res=>{
                    if (res.code==0){
                        this.getList()
                    }else{
                        Toast(res.msg)
                    }
                })

            },
            goBack(){
                this.$router.replace({path: '/'})
                //replace替换原路由，作用是避免回退死循环
            }
        },
        mounted(){
            document.querySelector('body').setAttribute('style', 'background-color:rgba(245,245,245,1)')
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
            }
        },
        destroyed(){
            window.removeEventListener('popstate', this.goBack, false);
        },
    }
</script>

<style scoped>
    .all-area{
        position: absolute;
        width: 100%;
        min-height: 100%;
        background:rgba(245,245,245,1);
    }
    .page{
        margin-top: 25px;
        margin-left: 16px;
        margin-right: 16px;
    }
    .notice-item{
        width:100%;
        height:206px;
        background:rgba(255,255,255,1);
        border-radius:12px;
        margin-bottom: 16px;
        margin-top: 16px;
    }
    .info-top{
        width: 100%;
        height: 56px;
        border-bottom: 1px solid #DFDFDF;
        margin-bottom: 16px;
    }
    .gem-name{
        font-size:17px;
        font-family:PingFangTC-Semibold,PingFangTC;
        font-weight:600;
        color:rgba(40,43,49,1);
        line-height:24px;
        margin-left: 16px;
    }
    .order-status{
        font-size:15px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(49,112,255,1);
        line-height:21px;
        margin-right: 16px;
    }
    .info-msg{
        font-size:12px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:17px;
        margin-bottom: 4px;
        margin-left: 16px;
    }
    .action-area{
        margin-top: 4px;
        margin-right: 16px;
    }
    .action{
        width:80px;
        height:29px;
        border-radius:15px;
        border:1px solid rgba(223,223,223,1);
        font-size:12px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:29px;
        text-align: center;
    }

</style>